import $ from "jquery";
import Header from "./components/Header.js";
import ButtonScrollTop from "./components/ButtonScrollTop.js";
import FilteringArticles from "./components/FilteringArticles.js";
import ArticlesPreviewsSlider from "./components/ArticlesPreviewsSlider.js";
import BooksPreviewsSlider from "./components/BooksPreviewsSlider.js";
import LibrarySlider from "./components/LibrarySlider.js";
import MediaGallery from "./components/MediaGallery.js";
import ExpertsAlphabetAnchors from "./components/ExpertsAlphabetAnchors.js";
import SearchResults from "./components/SearchResults.js";
import ErrorForm from "./components/ErrorForm.js";
import ContactsMap from "./components/ContactsMap.js";
import Swiper from "swiper";
import Disclaimer from "./components/Disclaimer.js";


if (!window.APP) {
    window.APP = {};
}



document.addEventListener("DOMContentLoaded", function() {

    new Header();



    $("#button-scroll-top").on("click", function(e) {
        e.preventDefault();
        $("html, body").animate({
            scrollTop: 0
        }, 500);
    });



    const partnersSliderElement = document.getElementById("partners-slider");
    if (partnersSliderElement) {
        const partnersSliderContainerElement = partnersSliderElement.querySelector(".js-partners-slider-container");
        const paginationElement = partnersSliderElement.querySelector(".js-partners-slider-pagination");

        new Swiper(partnersSliderContainerElement, {
            spaceBetween: 40,
            speed: 600,
            slidesPerView: 7,
            slidesPerGroup: 7,
            loop: true,
            slideClass: "js-partners-slider-slide",
            wrapperClass: "js-partners-slider-wrapper",
            navigation: {
                nextEl: ".js-partners-slider-button-next",
                prevEl: ".js-partners-slider-button-prev",
            },
            pagination: {
                el: paginationElement,
                type: "bullets",
                clickable: true,
                bulletClass: "partners-slider__pagination-item",
                bulletActiveClass: "is-active"
            },
        });
    }



    const articlesPreviewsSliderElements = document.querySelectorAll(".js-articles-previews-slider");

    for (let i = 0, len = articlesPreviewsSliderElements.length; i < len; i++) {
        new ArticlesPreviewsSlider(articlesPreviewsSliderElements[i]);
    }



    const booksPreviewsSliderElements = document.querySelectorAll(".js-books-previews-slider");

    for (let i = 0, len = booksPreviewsSliderElements.length; i < len; i++) {
        new BooksPreviewsSlider(booksPreviewsSliderElements[i]);
    }



    const librarySliderElements = document.querySelectorAll(".js-library-slider");

    for (let i = 0, len = librarySliderElements.length; i < len; i++) {
        new LibrarySlider(librarySliderElements[i]);
    }



    const mediaGalleryElements = document.querySelectorAll(".js-media-gallery");

    for (let i = 0, len = mediaGalleryElements.length; i < len; i++) {
        new MediaGallery(mediaGalleryElements[i]);
    }



    const mediaWidgetsElements = document.querySelectorAll(".js-media-widget");

    for (let i = 0, len = mediaWidgetsElements.length; i < len; i++) {
        initMediaWidget(mediaWidgetsElements[i]);
    }



    const filteringArticlesElements = document.querySelectorAll(".js-filtering-articles");

    for (let i = 0, len = filteringArticlesElements.length; i < len; i++) {
        new FilteringArticles(filteringArticlesElements[i]);
    }



    const expertsAlphabetAnchorsElement = document.getElementById("experts-alphabet-anchors");

    if (expertsAlphabetAnchorsElement) {
        new ExpertsAlphabetAnchors(expertsAlphabetAnchorsElement);
    }



    const searchResults = document.getElementById("search-results");

    if (searchResults) {
        new SearchResults(searchResults);
    }



    const contactsMapElement = document.getElementById("contacts-map");

    if (contactsMapElement) {
        new ContactsMap(contactsMapElement);
    }



    const errorFormElement = document.querySelector(".js-error-form");

    if (errorFormElement) {
        new ErrorForm(errorFormElement);
    }



    const buttonScrollTopElement = document.querySelector(".js-button-scroll-top");

    if (buttonScrollTopElement) {
        new ButtonScrollTop(buttonScrollTopElement);
    }



    const disclaimerElement = document.getElementById("disclaimer");

    if (disclaimerElement) {
        new Disclaimer(disclaimerElement);
    }



    function initMediaWidget(containerElement) {
        new Swiper(containerElement, {
            effect: "fade",
            loop: true,
            speed: 600,
            slideClass: "media-widget__item",
            wrapperClass: "js-media-widget-wrapper",
            navigation: {
                nextEl: ".js-media-widget-button-next",
                prevEl: ".js-media-widget-button-prev",
            }
        });
    }

}); // end "DOMContentLoaded"


// export { global, header, gallery, catalog, biography, navBlock, catalogFilters, backgroundAudioPlayer, initSections };